import Cookies from "../lib_react_frontend/utils/Cookies";

export default (state = {}, action) => {
  if (action.type === "set_empresa") {
    return action.empresa;
  }

  if (action.type === "define_empresa") {

    const empresa = Cookies.get("empresa");
    if (empresa) {
      return empresa;
    }
    return "";
  }
  return state;
};



// WEBPACK FOOTER //
// ./src/utils/empresaReducer.js